"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var extend_1 = __importDefault(require("extend"));
var TrackerUtil_1 = __importDefault(require("./TrackerUtil"));
var BasicTrackerAbstractImpl_1 = __importDefault(require("./BasicTrackerAbstractImpl"));
;
var MicrosoftUniversalEventTracking = /** @class */ (function (_super) {
    __extends(MicrosoftUniversalEventTracking, _super);
    function MicrosoftUniversalEventTracking(options) {
        var _this = _super.call(this, options) || this;
        _this.platformName = MicrosoftUniversalEventTracking.platformName;
        // Log information
        _this.getLogger().debug("MicrosoftUniversalEventTracking instance initialized.", "Options: ", options);
        return _this;
    }
    /**
     * @public
     */
    MicrosoftUniversalEventTracking.getInstance = function (options) {
        options = extend_1.default(true, {}, MicrosoftUniversalEventTracking.defaultOptions, options);
        var tracker = TrackerUtil_1.default.getInstance(options, MicrosoftUniversalEventTracking.instances, function (options) {
            return new MicrosoftUniversalEventTracking(options);
        });
        return tracker;
    };
    /**
     * @public
     */
    MicrosoftUniversalEventTracking.prototype.trackPageview = function (pagePath, title) {
        // Documentation: http://bingadsuet.azurewebsites.net/SPA_Index.html
        //    We will want to use "disableAutoPageView"
        pagePath = TrackerUtil_1.default.pagePathCleanup(pagePath);
        var fieldsObject = {
            page_path: pagePath
            // page_title		- conditionally setting below
            // page_location	- not used, and don't see documented
            // rep				- not used, and don't see documented
        };
        if (title !== undefined) {
            fieldsObject.page_title = title;
        }
        this.getPlatformInstance().push("event", "page_view", fieldsObject);
        // Log
        this.getLogger().debug("MicrosoftUniversalEventTracking.trackPageview:", fieldsObject);
    };
    /**
     * @public
     * The `nonInteraction` argument is not used.
     */
    MicrosoftUniversalEventTracking.prototype.trackEvent = function (category, action, label, value, nonInteraction) {
        // Documentation: https://help.ads.microsoft.com/#apex/3/en/56684/2
        var logger = this.getLogger();
        var fieldsObject = {
            event_category: category
        };
        action = TrackerUtil_1.default.eventActionToString(action);
        if (label !== undefined && label !== null) {
            fieldsObject.event_label = TrackerUtil_1.default.eventLabelToString(label);
        }
        if (value !== undefined && value !== null) {
            fieldsObject.event_value = value;
        }
        this.getPlatformInstance().push("event", action, fieldsObject);
        // Log
        logger.debug("MicrosoftUniversalEventTracking.trackEvent:", action, fieldsObject);
        if (nonInteraction !== undefined && nonInteraction !== null) {
            logger.debug("MicrosoftUniversalEventTracking.trackEvent does not use the nonInteraction argument. It has been ignored.");
        }
    };
    MicrosoftUniversalEventTracking.platformName = "MicrosoftUniversalEventTracking";
    MicrosoftUniversalEventTracking.instances = new Map();
    MicrosoftUniversalEventTracking.defaultOptions = {
        globalKeyForPlatform: "uetq"
    };
    return MicrosoftUniversalEventTracking;
}(BasicTrackerAbstractImpl_1.default));
exports.default = MicrosoftUniversalEventTracking;
